import {
  WorkflowEngineAction,
  WorkflowEngineActionKind
} from '../../../WorkflowEngine/workflowEngineReducer';
import PageState from '../../../Shared/pageState';
import getControlIdsToShow from './getControlIdsToShow';
import getControlsVisibility from './getControlsVisibility';

export default (
  pages: PageState[],
  workflowData: Record<string, unknown>,
  dispatch: (value: WorkflowEngineAction) => void
) => {
  const controlIdsToShow = getControlIdsToShow(pages, workflowData);
  const controlsVisibility = getControlsVisibility(pages, controlIdsToShow);

  dispatch({
    type: WorkflowEngineActionKind.CONTROLS_SET_VISIBLE,
    payload: controlsVisibility
  });
};
